import * as alarms from './alarms.actions';

export * from './alarms.actions';

export const ActionTypes = {
  ...alarms.AlarmsActionTypes,
};

export type Actions = alarms.AlarmsActions;


